import React from 'react';
import {Link} from 'react-router';
import flow from 'lodash/flow';
import {DropTarget, DragSource} from 'react-dnd';
import {findDOMNode} from 'react-dom';
import { FormattedMessage } from 'react-intl';

const style = {
    opacity: 0,
    cursor: 'auto'
};

const pageElementSource = {

    beginDrag(props, monitor, component) {
        return {
            id: props.id,
            index: props.index
        };
    },

    endDrag(props, monitor) {
        props.updateStorageData();
    },

    canDrag(props, monitor) {
        return props.ConfiguratorManager.isPageSortable();
    }
};

const pageElementTarget = {

    hover(props, monitor, component) {

        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.movePage(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};

class ConfiguratorMenuPageElement extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.onChangeVariant = this.onChangeVariant.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    };

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    onChangeVariant(newVariantId) {
      const {pageEntry, changePageVariant} = this.props;
      changePageVariant(pageEntry.id, newVariantId);
    }

    onChangePage(event, pageId) {
        event.preventDefault();
        const { redirectToPage, validatePage, ConfiguratorManager} = this.props;
        if (pageId !== ConfiguratorManager.getPageId()) {
          const cb = () => redirectToPage(pageId);
          validatePage(ConfiguratorManager.getPageId(), cb); // we validate the current page, not the page we will redirect!
        }
    }

    render() {

        const {pageEntry, removePage, ConfiguratorManager, isDragging, connectDragSource, connectDropTarget, canDrag, index, appConfig} = this.props;
        const opacity = isDragging ? 0 : 1;
        const cursor = canDrag ? 'ns-resize' : 'auto';
        const pageLink = `/configurator/${ConfiguratorManager.getDocumentId()}/${ConfiguratorManager.getStorageId()}/${pageEntry.id}`;

        let deleteButton = '';
        let classNamePageLink = 'page-link';
        if (pageEntry.deletable && pageEntry.deletable === true) {
            deleteButton = <button onClick={() => removePage(index)}><i className="material-icons">delete_sweep</i></button>
        }

        if (pageEntry.id.toString() === ConfiguratorManager.getPageId().toString()) {
            classNamePageLink = classNamePageLink + ' active';
        }

        let previewThumb;
        if (appConfig.configuratorPagePreviewImageSrc) {
            previewThumb = <img src={appConfig.configuratorPagePreviewImageSrc} />;
        }
        if (pageEntry.previewThumb) {
            previewThumb = <img src={pageEntry.previewThumb} />;
        }

        let pageLabel = <p>
            <Link to={pageLink} onClick={event => this.onChangePage(event, pageEntry.id)}>
              <FormattedMessage id="LABEL_PAGE" /> {index + 1}: {pageEntry.title}
            </Link>
            </p>;

        if (pageEntry.variants && pageEntry.variants instanceof Array && pageEntry.variants.length > 1) {

            pageLabel = <div><FormattedMessage id="LABEL_PAGE" /> {index + 1}: <select defaultValue={ pageEntry.variantId } onChange={changeEvent => this.onChangeVariant(changeEvent.target.value)}>
                {
                    pageEntry.variants.map(entry => {
                        return <option key={entry.id} value={entry.id}>{entry.title}</option>
                    })
                }
            </select></div>;
        }

        let html;


        if(pageEntry.id === "page-second-hidden") {
            html = <div></div>
        } else {
            html = <Link to={pageLink} onClick={event => this.onChangePage(event, pageEntry.id)}>
                <div style={{...style, opacity, cursor}} className={classNamePageLink}>
                    { pageLabel }
                    <div className="page-thumb-wrapper">
                        { previewThumb }
                        { deleteButton }
                    </div>
                </div>
            </Link>;
        }

        return connectDragSource(connectDropTarget(
            <div>
                {html}
            </div>
        ))
    }
}


export default flow(
    DragSource('CONFIGURATOR_PAGES_SORTABLE', pageElementSource, (connect, monitor) => ({
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
        canDrag: monitor.canDrag(),
    })),
    DropTarget('CONFIGURATOR_PAGES_SORTABLE', pageElementTarget, connect => ({
        connectDropTarget: connect.dropTarget()
    }))
)(ConfiguratorMenuPageElement);


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorMenuPageElement.react.jsx